import { InstagramEmbed } from "react-social-media-embed";
import { cn } from "@util/helpers";

type InstagramEmbedCustomProps = {
  /** Optional className for the embed container */
  className?: string;
  /** The URL of the Instagram embed */
  url: string;
};

const InstagramEmbedCustom = ({
  className,
  url,
}: InstagramEmbedCustomProps): React.ReactElement => {
  return (
    <div
      className={cn(
        "mb-6 flex justify-center [&>div]:w-full [&>div]:max-w-[550px]"
      )}
      data-testid="instagram-embed-custom-component"
    >
      <InstagramEmbed url={url} className={className} width={550} />
    </div>
  );
};

export default InstagramEmbedCustom;
